var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Button, CardTitle, Row } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { MyExportCSV } from './modules/DashboardTicket';
var Table2 = /** @class */ (function (_super) {
    __extends(Table2, _super);
    function Table2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Table2.prototype.render = function () {
        var _a = this.props, cardTitle = _a.cardTitle, columns = _a.columns, data = _a.data, keyField = _a.keyField, rowStyle = _a.rowStyle, rowEvents = _a.rowEvents, xlxs = _a.xlxs;
        var fileName = this.props.fileName || "".concat(this.props.cardTitle, "_at_").concat(new Date().toLocaleString(), ".csv");
        return (React.createElement("div", { className: "border m-1 rounded" },
            React.createElement("div", { className: "m-3" },
                React.createElement(Row, { className: "mb-1" },
                    React.createElement("div", { className: "col-12 col-sm-12" },
                        React.createElement(CardTitle, { className: "mb-1" }, "Ventas"),
                        React.createElement("div", { className: "small text-muted mt-1" }, cardTitle))),
                React.createElement(ToolkitProvider, { bootstrap4: true, 
                    /*exportCSV={{
                      fileName
                    }}*/
                    columns: columns, data: data, keyField: keyField, columnToggle: true }, function (props) { return (React.createElement("div", null,
                    xlxs && React.createElement(Button, { className: "btn btn-success react-bs-table-csv-btn btn-sm hidden-print", onClick: xlxs },
                        React.createElement("i", { className: "fa glyphicon glyphicon-export fa-download" }),
                        ' Export to XLXS'),
                    !xlxs && React.createElement(MyExportCSV, __assign({}, props.csvProps)),
                    React.createElement("hr", null),
                    React.createElement(BootstrapTable, __assign({ rowStyle: rowStyle, rowEvents: rowEvents, striped: true }, props.baseProps)))); }))));
    };
    return Table2;
}(Component));
export default Table2;



//////////////////
// WEBPACK FOOTER
// ./src/Table2.tsx
// module id = 1208
// module chunks = 0